import { useContext } from "react"
import { EditingContext } from "../context/editing-context"

export const useEditing = () => useContext(EditingContext)

